module.exports = __webpack_public_path__ + "static/home/img/4.3f149035.png";